"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global error boundary caught:", error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-surface-card text-themed-textPrimary p-6">
      <div className="max-w-md w-full space-y-4 text-center">
        <div className="text-5xl">⚠️</div>
        <h2 className="text-2xl font-semibold text-red-400">Something went wrong</h2>
        <p className="text-themed-textSecondary text-sm">
          An unexpected error occurred. The error has been logged.
        </p>
        {error.digest && (
          <p className="text-xs text-themed-textMuted font-mono">
            Error ID: {error.digest}
          </p>
        )}
        <button
          onClick={reset}
          className="mt-4 rounded-lg bg-[var(--accent-primary)] px-6 py-2 text-sm font-medium text-themed-textPrimary hover:bg-[var(--accent-primary)] transition-colors"
        >
          Try again
        </button>
      </div>
    </div>
  );
}